module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/1-bias.json
// module id = 331
// module chunks = 259082764533550